import React, { useEffect, useState } from "react";
import PreferencesDataContext from "./PreferencesDataContext";
import useGetPreferences from "../../../shared/hooks/Preferences/useGetPreferences";
import { accessTokenSelector } from "../../../auth/selectors/token";
import { useSelector } from "react-redux";
import { preferencesSelector } from "../../../settings/selectors/preferences";

const PreferencesContext = ({ children }) => {
  const [preferences, setPreferences] = useState(null);

  const companyPreferences = useGetPreferences();

  const token = useSelector(accessTokenSelector);
  const { company } = useSelector(preferencesSelector);

  useEffect(() => {
    if (!token) return;
    // If signIn saga already pre-fetched the config, use it directly from Redux.
    // Otherwise fetch it (e.g. on page reload where Redux is not persisted).
    if (company && Object.keys(company).length > 0) {
      setPreferences(company);
    } else {
      companyPreferences.get();
    }
  }, [token]);

  useEffect(() => {
    if (!companyPreferences.data) return;
    setPreferences(companyPreferences.data);
  }, [companyPreferences.data]);

  return (
    <PreferencesDataContext.Provider
      value={{
        preferences,
        setPreferences,
      }}
    >
      {children}
    </PreferencesDataContext.Provider>
  );
};

export default PreferencesContext;
